module.exports = __webpack_public_path__ + "img/philosophy.29c8982b.png";